export const KYC_SUBMITTED_ANIMATION = {
  SURVEY_CONTAINER_FADE_DURATION: 0.26,
  SURVEY_OPTION_INITIAL_X: -20,
  SURVEY_OPTION_FADE_DURATION: 0.22,
  SURVEY_OPTION_BASE_DELAY: 0.12,
  SURVEY_OPTION_STAGGER_DELAY: 0.05,
  THANKYOU_LOTTIE_INITIAL_Y: 36,
  THANKYOU_LOTTIE_FADE_DURATION: 0.45,
  THANKYOU_MESSAGE_FADE_DURATION: 0.35,
  THANKYOU_MESSAGE_FADE_DELAY: 0.45,
} as const;

export const KYC_SUBMITTED_VIEW_MODEL = {
  SURVEY_DISPLAY_DELAY_MS: 1000,
  LONG_WAIT_PHASE_DELAY_MS: 10000,
  SURVEY_OPTION_IDS: [
    'learning_financial_literacy',
    'sending_money_to_kids',
    'getting_kids_to_do_chores',
    'keeping_an_eye_on_spending',
    'other',
  ],
} as const;
